export const Breadcrumb = [
  { text: "Home", href: "/" },
  { text: "request status", href: "/request-status" },
  { text: "request detail", href: "/request-detail" },
];
